import React, { useState } from 'react';
import { XIcon, CheckIcon, ChevronDownIcon } from 'lucide-react';
import { MenuItem } from '../../lib/types';
import { formatCurrency } from '../../lib/utils';
const ACOMPANAMIENTOS = ['Papas fritas', 'Aros de cebolla', 'Camotes fritos', 'Papa en Gajo'] as const;
interface CabanaThursdayPromoModalProps {
  isOpen: boolean;
  onClose: () => void;
  burgers: MenuItem[];
  promoPrice: number;
  onConfirm: (notes: string) => void;
}
export function CabanaThursdayPromoModal({
  isOpen,
  onClose,
  burgers,
  promoPrice,
  onConfirm
}: CabanaThursdayPromoModalProps) {
  // 4 burger slots, each {burgerId, notes}
  const [picks, setPicks] = useState<{
    burgerId: string | null;
    notes: string;
  }[]>([{
    burgerId: null,
    notes: ''
  }, {
    burgerId: null,
    notes: ''
  }, {
    burgerId: null,
    notes: ''
  }, {
    burgerId: null,
    notes: ''
  }]);
  const [acompañamiento, setAcompanamiento] = useState<string | null>(null);
  const [openSlotIndex, setOpenSlotIndex] = useState<number | null>(null);
  if (!isOpen) return null;
  const setSlot = (index: number, patch: Partial<{
    burgerId: string | null;
    notes: string;
  }>) => {
    setPicks(prev => prev.map((p, i) => i === index ? {
      ...p,
      ...patch
    } : p));
  };
  const allBurgersPicked = picks.every(p => !!p.burgerId);
  const canConfirm = allBurgersPicked && !!acompañamiento;
  const handleConfirm = () => {
    if (!canConfirm) return;
    // Build a consolidated notes string the kitchen can read on the
    // KDS / WhatsApp / ticket.
    const lines = picks.map((p, i) => {
      const burger = burgers.find(b => b.id === p.burgerId);
      const name = burger?.name ?? '—';
      const note = p.notes.trim();
      return `• Burger ${i + 1}: ${name}${note ? ` — ${note}` : ''}`;
    });
    lines.push(`• Acompañamiento: ${acompañamiento}`);
    onConfirm(lines.join('\n'));
  };
  return <div className="fixed inset-0 z-[100] flex items-center justify-center p-4" onClick={onClose} data-id="element-2527" data-mp="1wediz8k6xbul">
      <div className="absolute inset-0 bg-black/70 backdrop-blur-sm" data-id="element-2528" data-mp="26aq77qwyuxhy" />
      <div className="relative bg-[#1A0B05] rounded-3xl shadow-2xl max-w-lg w-full max-h-[92vh] overflow-hidden border border-[#3A1F0F] flex flex-col" onClick={e => e.stopPropagation()} data-id="element-2529" data-mp="268na6mxec43q">
        {/* Header */}
        <div className="px-5 sm:px-6 pt-5 pb-4 border-b border-[#3A1F0F] flex items-start justify-between gap-3" data-id="element-2530" data-mp="2ba2zir6lwwrx">
          <div data-id="element-2531" data-mp="2p1hhcuos2rxe">
            <div className="inline-flex items-center gap-1.5 bg-[#FF6B35] text-white text-[10px] font-bold uppercase tracking-wider px-2 py-0.5 rounded-full mb-2" data-id="element-2532" data-mp="2ozwln1qq92xy">
              🔥 Promo Jueves
            </div>
            <h2 className="text-xl sm:text-2xl font-black text-[#FFB347] leading-tight" data-id="element-2533" data-mp="2yzx64r0c1p3q">
              4 Burgers + Acompañamiento
            </h2>
            <p className="text-xs text-[#C99A6A] mt-1" data-id="element-2534" data-mp="3dmdsczujuuye">
              Elegí 4 hamburguesas y 1 acompañamiento mediano por{' '}
              <span className="font-bold text-[#FF6B35]" data-id="element-2535" data-mp="3hmo8h5c231qz">
                {formatCurrency(promoPrice)}
              </span>
            </p>
          </div>
          <button type="button" onClick={onClose} aria-label="Cerrar" className="text-[#C99A6A] hover:text-white p-1 rounded-lg active:scale-95 transition-all" data-id="element-2536" data-mp="33qaonpk1uo9c">
            <XIcon className="w-5 h-5" data-id="element-2537" data-mp="2yolhikzy6uqj" />
          </button>
        </div>
        {/* Body */}
        <div className="flex-1 overflow-y-auto px-5 sm:px-6 py-4 space-y-5" data-id="element-2538" data-mp="2kxoynlvtprwo">
          {picks.map((p, idx) => <div key={idx} className="bg-[#0F0604] border border-[#3A1F0F] rounded-2xl p-4 space-y-3" data-id="element-2539" data-mp="2pw065pynbqbq" data-mpi={idx}>
              <div className="flex items-center justify-between" data-id="element-2540" data-mp="2b012crikkcce">
                <p className="text-xs font-bold uppercase tracking-wider text-[#FFB347]" data-id="element-2541" data-mp="2fxaonyanw7w0">
                  Hamburguesa {idx + 1}
                </p>
                {p.burgerId && <span className="inline-flex items-center gap-1 text-[10px] text-[#90C57F] font-semibold uppercase" data-id="element-2542" data-mp="3e9n4ebc64e9n">
                    <CheckIcon className="w-3 h-3" data-id="element-2543" data-mp="39i5c0bo7nm0a" />
                    Seleccionada
                  </span>}
              </div>
              {(() => {
            const selectedBurger = burgers.find(b => b.id === p.burgerId) || null;
            const isThisSlotOpen = openSlotIndex === idx;
            return <div data-id="element-2544" data-mp="2qkc6d1m7cxz7">
                    <button type="button" onClick={() => setOpenSlotIndex(isThisSlotOpen ? null : idx)} className="w-full bg-[#1A0B05] border border-[#3A1F0F] text-sm rounded-xl px-3 py-2.5 text-left flex items-center justify-between gap-2 hover:border-[#5C3018] focus:outline-none focus:ring-2 focus:ring-[#FF6B35]/60 transition-colors" data-id="element-2545" data-mp="2qlnc36z7kfsy">
                      <span className="min-w-0 flex-1" data-id="element-2546" data-mp="wcgpa24ii25i">
                        {selectedBurger ? <>
                            <span className="block text-[#FFE9CC] font-semibold truncate" data-id="element-2547" data-mp="114rsbduju42a">
                              {selectedBurger.name}
                            </span>
                            {selectedBurger.description && <span className="block text-[11px] text-[#C99A6A] mt-0.5 line-clamp-1" data-id="element-2548" data-mp="8h5qob4vt9i2">
                                {selectedBurger.description}
                              </span>}
                          </> : <span className="text-[#7A5A40]" data-id="element-2549" data-mp="n9z3tpwoldjk">
                            Elegí una hamburguesa…
                          </span>}
                      </span>
                      <ChevronDownIcon className={`w-4 h-4 text-[#C99A6A] shrink-0 transition-transform ${isThisSlotOpen ? 'rotate-180' : ''}`} data-id="element-2550" data-mp="1ytbn1o6rld2s" />
                    </button>
                    {isThisSlotOpen && <div className="bg-[#0F0604] border border-[#3A1F0F] rounded-xl max-h-72 overflow-y-auto p-1 mt-2" data-id="element-2551" data-mp="7omgng55zixm">
                        {burgers.map(b => {
                  const isSelected = p.burgerId === b.id;
                  return <button key={b.id} type="button" onClick={() => {
                    setSlot(idx, {
                      burgerId: b.id
                    });
                    setOpenSlotIndex(null);
                  }} className="w-full px-3 py-2.5 text-left flex items-start justify-between gap-3 hover:bg-[#1A0B05] rounded-lg border-b border-[#3A1F0F]/40 last:border-0 transition-colors" data-id="element-2552" data-mp="37513kmo183py">
                              <span className="min-w-0 flex-1" data-id="element-2553" data-mp="2j24muizdfqbx">
                                <span className="block text-[#FFE9CC] text-sm font-semibold" data-id="element-2554" data-mp="24c6vju65akii">
                                  {b.name}
                                </span>
                                {b.description && <span className="block text-[#C99A6A] text-xs leading-snug mt-0.5 line-clamp-2" data-id="element-2555" data-mp="2x0kss7petct0">
                                    {b.description}
                                  </span>}
                              </span>
                              {isSelected && <CheckIcon className="w-4 h-4 text-[#FF6B35] shrink-0 mt-0.5" data-id="element-2556" data-mp="2s06jynfzhytx" />}
                            </button>;
                })}
                      </div>}
                  </div>;
          })()}
              <textarea value={p.notes} onChange={e => setSlot(idx, {
            notes: e.target.value
          })} placeholder="Notas para esta hamburguesa (opcional)…" rows={2} className="w-full bg-[#1A0B05] border border-[#3A1F0F] text-[#FFE9CC] text-sm placeholder:text-[#7A5A40] rounded-xl px-3 py-2 focus:outline-none focus:ring-2 focus:ring-[#FF6B35]/60 resize-none" data-id="element-2557" data-mp="xtyx8chon0cy" />
            </div>)}
          {/* Acompañamiento */}
          <div className="bg-[#0F0604] border border-[#3A1F0F] rounded-2xl p-4 space-y-3" data-id="element-2558" data-mp="16ux3z2ji9lz8">
            <div className="flex items-center justify-between" data-id="element-2559" data-mp="12umvnj88qjh7">
              <p className="text-xs font-bold uppercase tracking-wider text-[#FFB347]" data-id="element-2560" data-mp="1zdaqw73aznjj">
                Acompañamiento mediano
              </p>
              <span className="text-[9px] font-bold uppercase tracking-wider text-[#FF6B35] bg-[#FF6B35]/15 px-2 py-0.5 rounded-full" data-id="element-2561" data-mp="1ul124udxctiu">
                Requerido
              </span>
            </div>
            <p className="text-[11px] text-[#7A5A40]" data-id="element-2562" data-mp="3i8f71wif1d9b">
              Se comparte para las 4 hamburguesas.
            </p>
            <div className="space-y-2" data-id="element-2563" data-mp="3r8tw96yi3ci3">
              {ACOMPANAMIENTOS.map(opt => {
              const selected = acompañamiento === opt;
              return <button key={opt} type="button" onClick={() => setAcompanamiento(opt)} className={`w-full flex items-center gap-3 px-3 py-2.5 rounded-xl border text-sm text-left transition-all ${selected ? 'border-[#FF6B35] bg-[#FF6B35]/10 text-white' : 'border-[#3A1F0F] bg-[#1A0B05] text-[#FFE9CC] hover:border-[#5C3018]'}`} data-id="element-2564" data-mp="2adn5mfai98">
                    <span className={`w-4 h-4 rounded-full border-2 flex items-center justify-center ${selected ? 'border-[#FF6B35] bg-[#FF6B35]' : 'border-[#5C3018]'}`} data-id="element-2565" data-mp="ns4qhn6qs6th">
                      {selected && <CheckIcon className="w-2.5 h-2.5 text-white" data-id="element-2566" data-mp="1dcumwuw8amw2" />}
                    </span>
                    {opt}
                  </button>;
            })}
            </div>
          </div>
        </div>
        {/* Footer */}
        <div className="px-5 sm:px-6 py-4 border-t border-[#3A1F0F] bg-[#0F0604] space-y-3" data-id="element-2567" data-mp="1r4iwaqf3ex9c">
          <div className="flex items-center justify-between text-sm" data-id="element-2568" data-mp="1w219wu4220no">
            <span className="text-[#C99A6A]" data-id="element-2569" data-mp="211xdwtcr5s38">Total promo</span>
            <span className="text-2xl font-black text-[#FF6B35]" data-id="element-2570" data-mp="212f6ng07ho6e">
              {formatCurrency(promoPrice)}
            </span>
          </div>
          <button type="button" disabled={!canConfirm} onClick={handleConfirm} className={`w-full font-bold text-sm uppercase tracking-wider py-3.5 rounded-2xl transition-all ${canConfirm ? 'bg-[#FF6B35] hover:bg-[#FF5722] active:scale-[0.98] text-white shadow-lg shadow-[#FF6B35]/30' : 'bg-[#3A1F0F] text-[#7A5A40] cursor-not-allowed'}`} data-id="element-2571" data-mp="6o5w36k9s1wp">
            {canConfirm ? 'Agregar promo al pedido' : 'Completá las 4 hamburguesas y el acompañamiento'}
          </button>
        </div>
      </div>
    </div>;
}